// @flow

import React, { type Node } from 'react';
import ebanxLogoSrc from '@tectonics/look-and-feel/volcanes/organisms/header/ebanx-logo-darkblue.svg';
import { FooterRoot, FooterContent, EbanxLogo } from './footer.styles';

export function Footer(): Node {
  return (
    <FooterRoot>
      <FooterContent>
        Pago seguro via
        <EbanxLogo src={ebanxLogoSrc} alt="EBANX" />
      </FooterContent>
    </FooterRoot>
  );
}
